import { NgxLoggerLevel } from 'ngx-logger';
import { FirebaseEnvironmentModel } from '@movinmotion/data-access-auth';

export enum AuthProviderName {
  myId = 'myId',
  tohero = 'tohero',
  movinmotion = 'movinmotion',
  deezer = 'deezer',
}

export const PROVIDER_BY_DOMAIN = {
  disney: AuthProviderName.myId,
  tohero: AuthProviderName.tohero,
  movinmotion: AuthProviderName.movinmotion,
  deezer: AuthProviderName.deezer,
};

export enum Language {
  fr = 'fr',
  en = 'en',
}

export interface Environment {
  production: boolean;
  defaultLanguage: Language;
  logger: {
    level: NgxLoggerLevel;
  };
  firebase: FirebaseEnvironmentModel;
  queryParamsKeys: {
    redirectUrl: string;
    resetPassword: string;
    changePassword: string;
    email: string;
    autoConnectUrl: string;
    language: string;
    display: string;
    providerConnection: string;
  };
  displayByAppHostEnabled: boolean;
  providers: { [key in AuthProviderName]: { id: string; enabled: boolean } };
  subscribeUrl: string;
  filmFranceSubscribeUrls: {
    worker: string;
    talents: string;
  };
  odalieSubscribeUrl: string;
  workerSubscribeUrl: string;
  envName: string;
  sentryDsn: string;
  thirdParty: {
    mixpanel: {
      enabled: boolean;
    };
  };
}
